import { useEffect } from "react";
import { CheckCircle2, X } from "lucide-react";

export default function ThankYouModal({ open, onClose }) {
  useEffect(() => {
    if (!open) return undefined;
    const esc = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", esc);
    return () => document.removeEventListener("keydown", esc);
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div role="presentation" className="fixed inset-0 z-[100] flex items-center justify-center bg-[#06132B]/70 p-4" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div role="dialog" aria-modal="true" aria-labelledby="bs-thanks" className="relative w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-2xl">
        <button type="button" onClick={onClose} aria-label="Close thank-you message" className="absolute right-4 top-4 rounded p-2 text-slate-500 hover:text-[#0B1F44]"><X size={20}/></button>
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-blue-50 text-[#0066FF]"><CheckCircle2 size={34}/></div>
        <h2 id="bs-thanks" className="mt-5 text-2xl font-bold text-[#0B1F44]">Thank you!</h2>
        <p className="mt-3 text-sm leading-relaxed text-slate-600">Your request has been submitted. BlueSettle will review your information and reach out about your rate comparison.</p>
        <button type="button" autoFocus onClick={onClose} className="mt-7 rounded-full bg-[#0066FF] px-9 py-3 font-semibold text-white">Close</button>
      </div>
    </div>
  );
}
